<template>
  <div>
    <video class="faceVideo" ref="video" :srcObject.prop="faceStream" autoplay muted />
  </div>
</template>

<script>
import { isMacOS } from '@/common/lib/strLib'
import { clearInterval, setInterval } from 'worker-timers'

export default {
  name: 'MediaRecorder',
  props: {
    isMuted: Boolean,
    form: Object,
    isMicGranted: Boolean,
  },
  created() {
    // this.getReady()
  },
  data() {
    return {
      videoOptions: {
        video: {
          deviceId: '',
          width: { min: 240, ideal: 480, max: 480 },
          height: { min: 240, ideal: 480, max: 480 },
          frameRate: 24,
        },
        audio: false,
      },
      recorderOptions: {
        videoBitsPerSecond: 1200000,
        mimeType: 'video/webm;codecs=h264',
      },
      faceStream: null,
      recorder: null,
      blobs: [],
      blob: null,

      audioRecorder: null,
      audioChunks: [],
      audioBlobs: [],
      audioChunkSize: 0,

      isComplete: false,
      // Canvas
      interval: null,
      captureCanvas: null,
      captureStream: null,
      ctx: null,
      startTime: null,
      pauseTime: null,
      totalPauseTime: 0,

      // stt audio start, pause time
      audioPauseTime: null,
      audioSilenceList: [],
    }
  },

  methods: {
    audioRecorderForSTT() {
      try {
        // audio Stream 이 없다면 시작하지 않음
        if (!this.faceStream || !this.faceStream.getAudioTracks() || this.faceStream.getAudioTracks().length === 0) {
          return
        }
        // 변수 초기화
        const limit = 1024 * 1024 * 20
        this.audioChunks = []
        this.audioChunkSize = 0

        const recorderOptions = {
          audioBitsPerSecond: 64000,
          mimeType: 'audio/webm',
        }
        const audioStream = new MediaStream()
        audioStream.addTrack(this.faceStream.getAudioTracks()[0])

        this.audioRecorder = new MediaRecorder(audioStream, recorderOptions)

        this.audioRecorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            this.audioChunks.push(event.data)
            this.audioChunkSize += event.data.size

            // blob 의 용량이 20MB 가 넘어가고, 녹화중이면 리코더 종료
            if (this.audioChunkSize >= limit && this.audioRecorder.state === 'recording') {
              this.audioRecorder.stop()
              this.audioPauseTime = new Date().getTime()
            }
          }
        }
        this.audioRecorder.onstop = () => {
          // 녹화가 끝났을 때 처리
          const blob = new Blob(this.audioChunks, {
            type: 'audio/webm',
          })
          this.audioBlobs.push(blob)

          // blob 의 용량이 20MB 가 넘어가서 끊긴거라면 다시 시작
          if (this.audioChunkSize >= limit) {
            this.audioRecorderForSTT()
          }
        }

        this.audioRecorder.start(10000)
        this.audioRecorder.pause()
      } catch (error) {
        console.log('error : ', error)
      }
    },
    async getReady() {
      this.videoOptions.video.deviceId = this.form.videoId
      if (this.isMicGranted) {
        this.videoOptions.audio = {
          deviceId: this.form.audioId,
          echoCancellation: true,
          noiseSuppression: true,
          sampleRate: 44100,
        }
        this.recorderOptions.audioBitsPerSecond = 128000
      }
      try {
        this.faceStream = await navigator.mediaDevices.getUserMedia(this.videoOptions)
        // this.$refs.video.srcObject = this.faceStream
        this.$emit('readyToStart', true)

        this.$emit('startAnalyser', { micStream: this.faceStream, micAndMediaStream: this.faceStream })
        return true
      } catch (err) {
        if (err !== undefined && err !== null) {
          let message = err.toString()
          if (message.includes('by system') && isMacOS()) {
            this.$store.dispatch('setShowPreferenceDialog', 'camera')
            // notify(this, 'Error', this.$t('systemDenied'), 'error')
          }
        }
        this.$emit('disableRecorder')
        this.$emit('readyToStart', false)
        return false
      }
    },
    startRecord() {
      try {
        this.captureCanvas = document.createElement('canvas')
        this.ctx = this.captureCanvas.getContext('2d')

        let faceVideo = this.$refs.video

        this.captureCanvas.width = faceVideo.videoWidth
        this.captureCanvas.height = faceVideo.videoHeight

        this.interval = setInterval(() => {
          if (this.captureCanvas && this.ctx) {
            // draw image with circle shape clip
            this.ctx.save()
            this.ctx.beginPath()
            this.ctx.arc(
              faceVideo.videoWidth / 2,
              faceVideo.videoWidth / 2,
              faceVideo.videoWidth / 2,
              0,
              Math.PI * 2,
              false
            )
            this.ctx.clip()
            this.ctx.scale(-1, 1)
            this.ctx.drawImage(faceVideo, -faceVideo.videoWidth, 0, faceVideo.videoWidth, faceVideo.videoHeight)
            this.ctx.restore()
          }
        }, 1000 / 30)

        let stream = [...this.captureCanvas.captureStream(30).getTracks()]
        if (this.isMicGranted) {
          this.faceStream.getAudioTracks()[0].enabled = !this.isMuted
          stream.push(...this.faceStream.getAudioTracks())
        }

        this.captureStream = new MediaStream(stream)

        try {
          this.recorder = new MediaRecorder(this.captureStream, this.recorderOptions)
        } catch (e0) {
          try {
            this.recorder = new MediaRecorder(this.captureStream, this.recorderOptions)
          } catch (e1) {
            try {
              this.recorder = new MediaRecorder(this.captureStream)
            } catch (e2) {
              return
            }
          }
        }

        this.recorder.onstart = () => {
          if (this.startTime === null) this.startTime = new Date().getTime()
        }
        this.recorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            this.blobs.push(event.data)
          }
        }
        this.recorder.onstop = () => {
          if (this.recorder != null) {
            this.blob = new Blob(this.blobs, {
              type: 'video/webm',
            })
            this.addTotalPauseTime()
            let duration = (new Date().getTime() - this.startTime) / 1000 - this.totalPauseTime
            this.$emit('saveBlob', {
              blob: this.blob,
              audioBlobs: this.audioBlobs,
              duration: duration,
              audioSilenceList: this.audioSilenceList,
            })
          }
        }

        localStorage.setItem('startTime', new Date().getTime())
        this.startTime = null
        this.audioPauseTime = null
        this.recorder.start(1000)

        // STT 를 사용하기 위한 audio recorder 추가
        if (this.faceStream && this.faceStream.getAudioTracks() && this.faceStream.getAudioTracks().length > 0) {
          this.audioSilenceList = []
          this.audioRecorderForSTT()
        }
      } catch (err) {
        console.error('Error: ' + err)
      }
    },

    sttRecorderPauseAndResume(isPause) {
      if (this.audioRecorder) {
        if (isPause && this.audioRecorder.state === 'recording') {
          this.audioPauseTime = new Date().getTime()
          this.audioRecorder.pause()
        } else if (!isPause && this.audioRecorder.state === 'paused') {
          this.audioRecorder.resume()

          let recordStart = this.startTime ?? localStorage.getItem('startTime')
          let pauseStart = !this.audioPauseTime ? 0 : Math.abs(this.audioPauseTime - recordStart) / 1000
          let pauseEnd = Math.abs(new Date().getTime() - recordStart) / 1000
          let duration = pauseEnd - pauseStart
          this.audioPauseTime = null
          this.audioSilenceList.push({
            start: pauseStart,
            end: pauseEnd,
            duration: duration,
          })
        }
      }
    },
    pauseResumeRecord(isClear) {
      if (isClear) {
        if (this.interval !== null) {
          clearInterval(this.interval)
          this.interval = null
        }

        this.blobs = []
        this.blob = null
        this.audioBlobs = []
        this.startTime = null
        this.pauseTime = null
        this.totalPauseTime = 0
        if (this.ctx !== null && this.captureCanvas !== null)
          this.ctx.clearRect(0, 0, this.captureCanvas.width, this.captureCanvas.height)
        delete this.captureCanvas
        this.captureCanvas = null
        if (this.recorder.state === 'recording') {
          this.recorder.pause()
          this.audioRecorder.pause()
        }
      } else {
        if (this.recorder.state === 'recording') {
          this.pauseTime = new Date().getTime()
          this.recorder.pause()
          this.audioRecorder.pause()
        } else if (this.recorder.state === 'paused') {
          this.addTotalPauseTime()
          this.recorder.resume()
          this.audioRecorder.resume()
        }
      }
    },
    addTotalPauseTime() {
      if (this.pauseTime && this.pauseTime !== null && this.pauseTime > 0)
        this.totalPauseTime += (new Date().getTime() - this.pauseTime) / 1000
      this.pauseTime = null
    },
    completeRecord() {
      if (this.audioRecorder !== null && this.audioRecorder.state !== 'inactive') this.audioRecorder.stop()
      if (this.recorder !== null && this.recorder.state !== 'inactive') this.recorder.stop()

      if (!this.faceStream) {
        setTimeout(() => {
          if (this.faceStream && this.faceStream.getTracks()) {
            this.faceStream.getTracks().forEach((track) => track.stop())
            this.faceStream = null
          }
        }, 1000)
      } else if (this.faceStream && this.faceStream !== null && this.faceStream.getTracks() !== null) {
        this.faceStream.getTracks().forEach((track) => track.stop())
        this.faceStream = null
      }
      if (this.captureStream && this.captureStream !== null && this.captureStream.getTracks() !== null) {
        this.captureStream.getTracks().forEach((track) => track.stop())
        this.captureStream = null
      }
    },
  },
  beforeDestroy() {
    if (this.interval !== null) {
      clearInterval(this.interval)
      this.interval = null
    }
    this.completeRecord()
    this.$emit('stopAnalyser')

    this.blobs = []
    this.blob = null
    this.audioBlobs = []
    this.recorder = null
    if (this.ctx !== null && this.captureCanvas !== null)
      this.ctx.clearRect(0, 0, this.captureCanvas.width, this.captureCanvas.height)
    delete this.captureCanvas
    this.captureCanvas = null
  },
  watch: {
    isMuted(val) {
      if (this.isMicGranted) {
        if (this.faceStream !== undefined && this.faceStream !== null) {
          this.faceStream.getAudioTracks().forEach((track) => (track.enabled = !val))
          if (!val) this.$emit('startAnalyser', { micStream: this.faceStream, micAndMediaStream: this.faceStream })
        } else this.getReady()
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler() {
        this.getReady()
      },
    },
  },
}
</script>

<style scoped>
.faceVideo {
  border-radius: 240px;
  transform: scale(-1, 1);
}
</style>
